module.exports = __webpack_public_path__ + "static/img/pitch_grey.70bbbca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_grey.png
// module id = d54U
// module chunks = 94